<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="エクストラサイト一覧(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-3">
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn color="primary" @click="toAddSite"> 追加 </v-btn>
                <v-btn color="primary" @click="toDelete"> 削除 </v-btn>
              </v-col>
            </v-row>
            <v-alert v-model="showAlert" class="my-2">{{
              $filter.message("no_select_data")
            }}</v-alert>
            <app-table
              v-model:table-sort-by="siteList.sortBy"
              :fields="siteList.fields"
              :items="siteList.items"
              :hover="true"
              :selectable="true"
              :per-page="-1"
              v-model="siteList.selected"
              primary-key="siteId"
              @click:row="extraSelected"
            >
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type {
  Type1ExtraInfo,
  Type1ExtraSiteDelete,
  Type1Site,
} from "@/apis/Type1SiteApi";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import ExtraSiteReference from "@/modals/type1/ExtraSiteReference.vue";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";
import ExtraSiteEdit from "@/modals/type1/ExtraSiteEdit.vue";

export default defineComponent({
  name: "ExtraSiteList",
  props: {
    extraSiteZone: {
      type: Object as PropType<Type1ExtraInfo>,
      required: true,
    },
  },
  data() {
    return {
      showAlert: false as boolean,
      siteList: {
        sortBy: {
          key: "siteName",
          order: "asc",
        } as SortItem,
        fields: [
          {
            key: "siteName",
            title: "サイト名",
            sortable: true,
          },
        ] as AppTableHeader<Type1Site>[],
        items: [] as Type1Site[],
        selected: [],
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.siteList.items = this.extraSiteZone.siteList;
    },
    /** 追加機能 */
    async toAddSite() {
      this.showAlert = false;
      await this.$modal.show(ExtraSiteEdit, {
        extraZone: this.extraSiteZone.zone,
        type1SiteZoneKeyId: this.extraSiteZone.type1SiteZoneKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 行選択機能 */
    async extraSelected(item: Type1Site) {
      this.showAlert = false;
      await this.$modal.show(ExtraSiteReference, {
        extraSite: item,
        extraZone: this.extraSiteZone.zone,
        type1SiteZoneKeyId: this.extraSiteZone.type1SiteZoneKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 削除機能 */
    async toDelete() {
      this.showAlert = this.siteList.selected.length === 0;
      if (this.showAlert) return;

      await this.$confirm(
        `エクストラサイトを${this.siteList.selected.length}件削除します。よろしいですか？`
      );

      const reqData: Type1ExtraSiteDelete = {
        siteList: this.siteList.selected.map((e: Type1Site) => {
          return e.siteId;
        }),
        type1SiteZoneKeyId: this.extraSiteZone.type1SiteZoneKeyId,
      };

      await this.$api.type1SiteZone.postType1ExtraSiteDelete(reqData);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
